import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {IconButton, Grid, Box} from "@mui/material";
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  withClickableCell,
  resolveGridRow,
} from "../../grid/iLocalAGGrid";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";

const PaymentGatewaysEnum = require('../../common/payment-gateways').default;

const SUPPORTED_REFUND_GATEWAYS = [
  PaymentGatewaysEnum.GLOBAL_PAYMENTS_GENIUS,
  PaymentGatewaysEnum.FISERV_CARDPOINTE,
  PaymentGatewaysEnum.TRUST_COMMERCE,
];

const GATEWAY_FILTER_OPTIONS = [
  { value: "all", label: "All Gateways" },
];

const GATEWAY_LABELS = [
  { value: PaymentGatewaysEnum.GLOBAL_PAYMENTS, label: "Global Payments" },
  { value: PaymentGatewaysEnum.GLOBAL_PAYMENTS_GENIUS, label: "Global Payments Genius" },
  { value: PaymentGatewaysEnum.FISERV_CARDPOINTE, label: "Fiserv CardPointe" },
  { value: PaymentGatewaysEnum.TRUST_COMMERCE, label: "TrustCommerce" },
  { value: PaymentGatewaysEnum.AXIAMED, label: "AxiaMed" },
];

GATEWAY_FILTER_OPTIONS.push(...GATEWAY_LABELS);

const getGatewayLabel = (gatewayId) => {
  const matchedGateway = GATEWAY_LABELS.find((option) => option.value === gatewayId);
  return matchedGateway ? matchedGateway.label : "Unknown";
};


class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      { id: "firstname", numeric: false, disablePadding: false, label: t("Report.iPay.FirstName"), padding: '10px', field: 'first_name' },
      { id: "lastname", numeric: false, disablePadding: false, label: t("Report.iPay.LastName"), padding: '10px', field: 'last_name' },
      { id: "PRN", numeric: false, disablePadding: false, label: t("Report.iPay.PRN"), padding: '10px', field: 'patient_id' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.iPay.Store"), padding: '10px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.iPay.Location"), padding: '10px', field: 'name' },
      { id: "pucode", numeric: false, disablePadding: false, label: t("Report.iPay.PUCode"), padding: '10px', field: 'pucode' },
      { id: "transaction_id", numeric: false, disablePadding: false, label: t("Report.iPay.TransactionID"), padding: '10px', field: 'sales_id' },
      { id: "trans_status", numeric: false, disablePadding: false, label: t("Report.iPay.TransactionStatus"), padding: '10px', field: 'trans_status' },
      { id: "masked_card_number", numeric: false, disablePadding: false, label: t("Report.iPay.CardNumber"), padding: '10px', field: 'masked_card_number' },
      { id: "card_type", numeric: false, disablePadding: false, label: t("Report.iPay.CardType"), padding: '10px', field: 'card_type' },
      { id: "card_brand", numeric: false, disablePadding: false, label: t("Report.iPay.CardBrand"), padding: '10px', field: 'card_brand' },
      { id: "entry_type", numeric: false, disablePadding: false, label: t("Report.iPay.EntryType"), padding: '10px', field: 'entry_type' },
      { id: "reference_id", numeric: false, disablePadding: false, label: t("Report.iPay.ReferenceID"), padding: '10px', field: 'reference_id' },
      { id: "payment_date", numeric: false, disablePadding: false, label: t("Report.iPay.PaymentDateTime"), padding: '10px', field: 'payment_date' },
      { id: "payment_type", numeric: false, disablePadding: false, label: t("Report.iPay.PaymentType"), padding: '10px', field: 'payment_type' },
      { id: "currency_code", numeric: false, disablePadding: false, label: t("Report.iPay.CurrencyCode"), padding: '10px', field: 'currency_code' },
      { id: "approved_amt", numeric: false, disablePadding: false, label: t("Report.iPay.TotalAmount"), padding: '10px', field: 'approved_amt' },
      { id: "type", numeric: false, disablePadding: false, label: t("Report.iPay.Type"), padding: '10px', field: 'type' },
      { id: "selected_payment_gateway", numeric: false, disablePadding: false, label: "Gateway", padding: '10px', field: 'selected_payment_gateway' }
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
              >
                {[
                  "transaction_id",
                  "masked_card_number",
                  "reference_id",
                  "currency_code",
                  "approved_amt",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '10px'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'payment_date',
  tableName: '',
  group_id: null,
  timezone: '',
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "payment_date",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      selectedObject: null,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      queryId: "",
      groups: [],
      isRefundSubmitting: false,
      isVoidSubmitting: false,
      refundStatusMessage: "",
      refundStatusType: "",
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['payment_date'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "getiPayTransaction", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'payment_date');
  };

  componentDidMount() {
    // Get user's timezone for date filtering
    let userTimeZone = sessionStorage.getItem('timeZone');
    if (['null', null, 'undefined', undefined, ''].includes(userTimeZone)) {
      userTimeZone = defaultZone;
    }
    TransactionFilterObj.timezone = userTimeZone.substring(userTimeZone.lastIndexOf(' ') + 1);
    
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        let All = [{ id: "-1", name: this.props.t('All') }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(TransactionFilterObj, {
      store_ids: [],
      box_ids: [],
      searchtext: '',
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'payment_date',
      tableName: '',
      timezone: TransactionFilterObj.timezone, // Preserve timezone
      selected_payment_gateway: 'all'});
    this.fetchSuggestions();
    this.setState({ loader: false });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  escapeCsvField(field) {
    if (field === null || field === undefined) {
      return '';
    }

    // Always quote and escape embedded double quotes (RFC 4180) so commas,
    // #, newlines, quotes, and any other special characters cannot break CSV columns/rows
    return '"' + String(field).replace(/"/g, '""') + '"';
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/iPayTransactionReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        this.setState({ loader: false });
        let csvRow = [];
        const headers = ['FirstName', 'LastName', 'Patient Record Number', 'Store', 'Box', 'PickUpCode', 'TransactionID', 'TransationStatus', 'CardNumber', 'CardType', 'CardBrand', 'EntryType', 'ReferenceID', 'PaymentDate/Time', 'PaymentType', 'CurrencyCode', 'TotalAmount', 'Type', 'Gateway'];
        csvRow.push(headers.map(h => this.escapeCsvField(h)).join(','));
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              const row = [
                this.escapeCsvField(i.firstname),
                this.escapeCsvField(i.lastname),
                this.escapeCsvField(i.PRN),
                this.escapeCsvField(i.store),
                this.escapeCsvField(i.box),
                this.escapeCsvField(i.pucode),
                this.escapeCsvField(i.transaction_id),
                this.escapeCsvField(i.trans_status),
                this.escapeCsvField(i.masked_card_number),
                this.escapeCsvField(i.card_type),
                this.escapeCsvField(i.card_brand),
                this.escapeCsvField(i.entry_type),
                this.escapeCsvField(i.reference_id),
                this.escapeCsvField(i.payment_date ? this.convertToTimeZone(i && i.payment_date) : ''),
                this.escapeCsvField(i.payment_type || i.card_type),
                this.escapeCsvField(i.currency_code),
                this.escapeCsvField(i.approved_amt ? '$' + parseFloat(i.approved_amt).toFixed(2) : '$0.00'),
                this.escapeCsvField(i.type),
                this.escapeCsvField(getGatewayLabel(i.selected_payment_gateway))
              ];
              csvRow.push(row.join(','));
            }

            // Use Blob instead of data URI — data URIs truncate at special chars like "#"
            let csvString = csvRow.join('\n');
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            let element = document.createElement('a');
            element.href = url;
            element.download = 'iPayTransactionReport.csv';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            URL.revokeObjectURL(url);
          }
        }
      })
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['firstname', 'lastname', 'PRN'].includes(field)) {
      tablename = 'customers';
    }
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts';
    }
    if (['pucode'].includes(field)) {
      tablename = 'prescriptions_master';
    }
    if (['trans_status', 'selected_payment_gateway', 'card_type', 'card_brand', 'entry_type', 'payment_date', 'payment_type'].includes(field)) {
      tablename = 'payments';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          let All = [{ id: "-1", name: this.props.t('All') }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });

    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.boxvalues[0]];
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }

    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  handleGatewayFilterChange = (event) => {
    const selectedPaymentGateway = event.target.value;
    this.setState({ selectedPaymentGateway });
    TransactionFilterObj.selected_payment_gateway = selectedPaymentGateway;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'payment_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };
  handlePUcodeClick = (event, transaction_id) => {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    const selectedObject = resolveGridRow(
      transaction_id,
      this.state.data,
      (x, id) => (x.transaction_id || x.trans_id) === id
    );
    if (!selectedObject) return;
    let ReceiptObj = null;
    try {
      ReceiptObj = selectedObject && selectedObject.receipt ? JSON.parse(selectedObject.receipt) : null;
    } catch (error) {
      ReceiptObj = null;
    }
    let paymentDetail;
    const paymentGateway = selectedObject && selectedObject.selected_payment_gateway;
    const isGlobalPaymentsGenius = paymentGateway === PaymentGatewaysEnum.GLOBAL_PAYMENTS_GENIUS;
    const paymentDetailsobj = ReceiptObj && ReceiptObj.labeled_attributes;
    const formattedName = `${selectedObject && selectedObject.firstname ? selectedObject.firstname.trim().charAt(0) : ""}. ${selectedObject && selectedObject.lastname ? selectedObject.lastname.substring(0, 3) : ""}.`;
    const getFormattedAmount = (amountValue) => {
      if (amountValue === null || amountValue === undefined || amountValue === "") {
        return "$0.00";
      }
      const cleanedAmount = String(amountValue).replace("USD", "").replace(/[^0-9.-]/g, "");
      const parsedAmount = parseFloat(cleanedAmount);
      return Number.isNaN(parsedAmount) ? "$0.00" : "$" + parsedAmount.toFixed(2);
    };
    // Explicit gateway handling: Global Payments + Global Payments Genius.
    // Treat anything that is not Genius as Global Payments (including null/empty/unknown).
    if (isGlobalPaymentsGenius) {
      const responseAmount = selectedObject && selectedObject.approved_amt;
      const receiptAmount = ReceiptObj && ReceiptObj.AmountApproved;
      const labeledAmount = paymentDetailsobj && paymentDetailsobj.total_amount && paymentDetailsobj.total_amount.value;
      paymentDetail = {
        username: formattedName,
        receiptNumber: (ReceiptObj && (ReceiptObj.ValidationKey || ReceiptObj.id)) || "",
        batch: (selectedObject && selectedObject.batch_no) || "",
        transactionId: (selectedObject && (selectedObject.trans_id || selectedObject.transaction_id)) || (ReceiptObj && ReceiptObj.Token) || "",
        transactionStatus: (selectedObject && (selectedObject.trans_status || selectedObject.result_message || selectedObject.host_response_description)) || (ReceiptObj && (ReceiptObj.Status || ReceiptObj.ErrorMessage)) || "",
        referenceId: (selectedObject && selectedObject.reference_id) || (ReceiptObj && ReceiptObj.HostReferenceId) || "",
        transactionType: (selectedObject && selectedObject.type) || (ReceiptObj && ReceiptObj.TransactionType) || "",
        remoteId: (selectedObject && selectedObject.remote_id) || "",
        dateTime: (selectedObject && selectedObject.payment_date ? this.convertToTimeZone(selectedObject.payment_date) : "") || (ReceiptObj && ReceiptObj.TransactionDate) || "",
        cardHolderName: (selectedObject && selectedObject.card_holder) || (ReceiptObj && (ReceiptObj.CardHolder || ReceiptObj.Cardholder)) || "",
        cardType: (selectedObject && selectedObject.card_type) || (ReceiptObj && ReceiptObj.PaymentType) || "",
        cardNumber: (selectedObject && (selectedObject.masked_card_number || selectedObject.account_no)) || (ReceiptObj && ReceiptObj.AccountNumber) || "",
        cardExpirationDate: (selectedObject && selectedObject.exp_month && selectedObject.exp_year) ? `${selectedObject.exp_month}/${selectedObject.exp_year}` : ((ReceiptObj && ReceiptObj.AdditionalParameters && ReceiptObj.AdditionalParameters.EMV && ReceiptObj.AdditionalParameters.EMV.CardInformation && ReceiptObj.AdditionalParameters.EMV.CardInformation.CardExpiryDate) || ""),
        entryMethod: (selectedObject && selectedObject.entry_type) || (ReceiptObj && ReceiptObj.EntryMode) || "",
        approvalCode: (selectedObject && selectedObject.approved_code) || (ReceiptObj && ReceiptObj.AuthorizationCode) || "",
        totalAmount: getFormattedAmount(responseAmount || receiptAmount || labeledAmount),
        payment_id: selectedObject && selectedObject.payment_id,
        order_id: selectedObject && selectedObject.order_id,
        customer_id: selectedObject && selectedObject.customer_id,
        sales_id: (selectedObject && selectedObject.transaction_id) || "",
        trans_id: (selectedObject && selectedObject.trans_id) || "",
        box_id: selectedObject && selectedObject.boxid,
        refundToken: (ReceiptObj && ReceiptObj.Token) || "",
        cardAcceptorTerminalId: (ReceiptObj && ReceiptObj.CardAcceptorTerminalId) || "",
        paymentGateway,
        paymentGatewayLabel: getGatewayLabel(paymentGateway),
      };
      this.setState({
        detailDialogOpen: true,
        selectedObject: paymentDetail,
        refundStatusMessage: "",
        refundStatusType: "",
      });
    } else {
      const responseAmount = selectedObject && selectedObject.approved_amt;
      const labeledAmount = paymentDetailsobj && paymentDetailsobj.total_amount && paymentDetailsobj.total_amount.value;
      const receiptAmount = ReceiptObj && ReceiptObj.AmountApproved;
      paymentDetail = {
        username: formattedName,
        receiptNumber: (ReceiptObj && (ReceiptObj.id || ReceiptObj.ValidationKey)) || "",
        batch: (selectedObject && selectedObject.batch_no) || (paymentDetailsobj && paymentDetailsobj.batch_number && paymentDetailsobj.batch_number.value) || "",
        transactionId: (selectedObject && (selectedObject.transaction_id || selectedObject.trans_id)) || (paymentDetailsobj && paymentDetailsobj.transaction_id && paymentDetailsobj.transaction_id.value) || (ReceiptObj && ReceiptObj.Token) || "",
        transactionStatus: (selectedObject && (selectedObject.trans_status || selectedObject.result_message || selectedObject.host_response_description)) || (ReceiptObj && (ReceiptObj.Status || ReceiptObj.ErrorMessage)) || "",
        referenceId: (selectedObject && selectedObject.reference_id) || (paymentDetailsobj && paymentDetailsobj.reference_id && paymentDetailsobj.reference_id.value) || "",
        transactionType: (selectedObject && selectedObject.type) || (paymentDetailsobj && paymentDetailsobj.transaction_type && paymentDetailsobj.transaction_type.value) || (ReceiptObj && ReceiptObj.TransactionType) || "",
        remoteId: (selectedObject && selectedObject.remote_id) || "",
        dateTime: (selectedObject && selectedObject.payment_date ? this.convertToTimeZone(selectedObject.payment_date) : "") || (paymentDetailsobj && paymentDetailsobj.transaction_datetime && paymentDetailsobj.transaction_datetime.value) || (ReceiptObj && ReceiptObj.TransactionDate) || "",
        cardHolderName: (selectedObject && selectedObject.card_holder) || (ReceiptObj && (ReceiptObj.CardHolder || ReceiptObj.Cardholder)) || "",
        cardType: (selectedObject && selectedObject.card_type) || (paymentDetailsobj && paymentDetailsobj.card_type && paymentDetailsobj.card_type.value) || (ReceiptObj && ReceiptObj.PaymentType) || "",
        cardNumber: (selectedObject && (selectedObject.masked_card_number || selectedObject.account_no)) || (paymentDetailsobj && paymentDetailsobj.masked_card_number && paymentDetailsobj.masked_card_number.value) || (ReceiptObj && ReceiptObj.AccountNumber) || "",
        cardExpirationDate: (selectedObject && selectedObject.exp_month && selectedObject.exp_year) ? `${selectedObject.exp_month}/${selectedObject.exp_year}` : ((ReceiptObj && ReceiptObj.AdditionalParameters && ReceiptObj.AdditionalParameters.EMV && ReceiptObj.AdditionalParameters.EMV.CardInformation && ReceiptObj.AdditionalParameters.EMV.CardInformation.CardExpiryDate) || ""),
        entryMethod: (selectedObject && selectedObject.entry_type) || (paymentDetailsobj && paymentDetailsobj.entry_method && paymentDetailsobj.entry_method.value) || (ReceiptObj && ReceiptObj.EntryMode) || "",
        approvalCode: (selectedObject && selectedObject.approved_code) || (paymentDetailsobj && paymentDetailsobj.approval_code && paymentDetailsobj.approval_code.value) || (ReceiptObj && ReceiptObj.AuthorizationCode) || "",
        totalAmount: getFormattedAmount(responseAmount || labeledAmount || receiptAmount),
        payment_id: selectedObject && selectedObject.payment_id,
        order_id: selectedObject && selectedObject.order_id,
        customer_id: selectedObject && selectedObject.customer_id,
        sales_id: (selectedObject && selectedObject.transaction_id) || "",
        trans_id: (selectedObject && selectedObject.trans_id) || "",
        box_id: selectedObject && selectedObject.boxid,
        refundToken: (ReceiptObj && ReceiptObj.Token) || "",
        cardAcceptorTerminalId: (ReceiptObj && ReceiptObj.CardAcceptorTerminalId) || "",
        paymentGateway,
        paymentGatewayLabel: getGatewayLabel(paymentGateway),
      };
      this.setState({
        detailDialogOpen: true,
        selectedObject: paymentDetail,
        refundStatusMessage: "",
        refundStatusType: "",
      });
    }
  }
  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({
      detailDialogOpen: false,
      selectedObject: null,
      refundStatusMessage: "",
      refundStatusType: "",
    })
  }

  handleRefund = async () => {
    const selectedObject = this.state.selectedObject;
    if (!selectedObject) return;
    if (!SUPPORTED_REFUND_GATEWAYS.includes(selectedObject.paymentGateway)) {
      this.setState({
        refundStatusMessage: "Refund is not supported for this payment gateway.",
        refundStatusType: "error",
      });
      return;
    }

    const totalAmount = parseFloat(String(selectedObject.totalAmount || "").replace(/[^0-9.-]/g, ""));
    if (!Number.isFinite(totalAmount) || totalAmount <= 0) {
      this.setState({
        refundStatusMessage: "Unable to determine refund amount.",
        refundStatusType: "error",
      });
      return;
    }

    this.setState({
      isRefundSubmitting: true,
      refundStatusMessage: "",
      refundStatusType: "",
    });
    try {
      const result = await fetch(`${process.env.REACT_APP_BASEURL}refundPayment`, {
        method: "POST",
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          paymentId: selectedObject.payment_id || null,
          salesId: selectedObject.sales_id || null,
          transactionId: selectedObject.trans_id || selectedObject.transactionId || null,
          orderId: selectedObject.order_id || null,
          boxId: selectedObject.box_id || null,
          refundAmount: totalAmount,
          previousTransactionToken: selectedObject.refundToken || null,
          merchantTransactionId: selectedObject.trans_id || selectedObject.transactionId || null,
          cardAcceptorTerminalId: selectedObject.cardAcceptorTerminalId || null,
          invoiceNumber: selectedObject.order_id || selectedObject.receiptNumber || null,
          registerNumber: "1",
          selectedPaymentGateway: selectedObject.paymentGateway || null,
        })
      });

      const payload = await result.json();
      if (!result.ok || !payload || payload.success === false) {
        throw new Error((payload && payload.message) || "Refund failed.");
      }
      this.setState({
        refundStatusMessage: payload.message || "Refund processed successfully.",
        refundStatusType: "success",
      });
      this.BindGrid();
    } catch (error) {
      this.setState({
        refundStatusMessage: error && error.message ? error.message : "Refund failed.",
        refundStatusType: "error",
      });
    } finally {
      this.setState({ isRefundSubmitting: false });
    }
  };

  handleVoid = async () => {
    const selectedObject = this.state.selectedObject;
    if (!selectedObject) return;
    if (selectedObject.paymentGateway !== PaymentGatewaysEnum.TRUST_COMMERCE) {
      this.setState({
        refundStatusMessage: "Void is only supported for TrustCommerce.",
        refundStatusType: "error",
      });
      return;
    }

    this.setState({
      isVoidSubmitting: true,
      refundStatusMessage: "",
      refundStatusType: "",
    });
    try {
      const result = await fetch(`${process.env.REACT_APP_BASEURL}refundPayment`, {
        method: "POST",
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          salesId: selectedObject.sales_id || null,
          transactionId: selectedObject.trans_id || selectedObject.transactionId || null,
          orderId: selectedObject.order_id || null,
          boxId: selectedObject.box_id || null,
          actionType: "void",
          previousTransactionToken: selectedObject.refundToken || null,
          merchantTransactionId: selectedObject.trans_id || selectedObject.transactionId || null,
          cardAcceptorTerminalId: selectedObject.cardAcceptorTerminalId || null,
          invoiceNumber: selectedObject.order_id || selectedObject.receiptNumber || null,
          registerNumber: "1",
          selectedPaymentGateway: selectedObject.paymentGateway || null,
        })
      });

      const payload = await result.json();
      if (!result.ok || !payload || payload.success === false) {
        throw new Error((payload && payload.message) || "Void failed.");
      }
      this.setState({
        refundStatusMessage: payload.message || "Void processed successfully.",
        refundStatusType: "success",
      });
      this.BindGrid();
    } catch (error) {
      this.setState({
        refundStatusMessage: error && error.message ? error.message : "Void failed.",
        refundStatusType: "error",
      });
    } finally {
      this.setState({ isVoidSubmitting: false });
    }
  };
  PrintDetails = () => {
    setTimeout(() => {
      window.print();
      this.setState({ detailDialogOpen: false, selectedObject: null })
    }, 1000);
  }

  returnReceiptDetails = (selectedObject, classes) => {
    const {t} = this.props;
    if (!selectedObject) {
      return (<TableBody>
        <TableRow>
          <TableCell colSpan={5}>{t("Report.iPay.NoDataFound")}</TableCell>
        </TableRow>
      </TableBody>);
    }
    return (<TableBody>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.BatchHash")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.batch}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionID")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.transactionId}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionStatus")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.transactionStatus}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>Gateway</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.paymentGatewayLabel || getGatewayLabel(selectedObject.paymentGateway)}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ReceiptNumber")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.receiptNumber}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ReferenceID")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.referenceId}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TransactionType")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.transactionType}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.RemoteID")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.remoteId}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.DateTime")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.dateTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardHolderName")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.cardHolderName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardType")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.cardType}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.CardNumber")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.cardNumber}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ExpirationDate")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.cardExpirationDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.EntryMethod")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.entryMethod}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.ApprovalCode")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.approvalCode}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.iPay.Popup.TotalAmount")}</TableCell>
        <TableCell className={classes.padding10px}>{selectedObject.totalAmount}</TableCell>
      </TableRow>
    </TableBody>);
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, t} = this.props;
    
    return (
      <div id="react-no-print" className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={'md'}
          >
            <DialogTitle id="alert-dialog-title">{`${this.state && this.state.selectedObject && this.state.selectedObject.username}'s ${t("Report.iPay.Popup.PaymentDetail")}`}</DialogTitle>
            <DialogContent>
              <Table aria-labelledby="tableTitle">
                {
                  this.returnReceiptDetails(this.state.selectedObject, classes)
                }
              </Table>
            </DialogContent>
            <DialogActions id="react-no-print">
              {this.state.refundStatusMessage && (
                <Typography
                  sx={{ flex: 1, pl: 2 }}
                  color={this.state.refundStatusType === "success" ? "success.main" : "error.main"}
                >
                  {this.state.refundStatusMessage}
                </Typography>
              )}
              {this.state.selectedObject && this.state.selectedObject.paymentGateway === PaymentGatewaysEnum.TRUST_COMMERCE && (
                <Button
                  onClick={this.handleVoid}
                  color="primary"
                  className={classes.primaryButton}
                  disabled={this.state.isRefundSubmitting || this.state.isVoidSubmitting}
                >
                  {this.state.isVoidSubmitting ? "Voiding..." : "Void (Before Settlement)"}
                </Button>
              )}
              {this.state.selectedObject && SUPPORTED_REFUND_GATEWAYS.includes(this.state.selectedObject.paymentGateway) && (
                <Button
                  onClick={this.handleRefund}
                  color="primary"
                  className={classes.primaryButton}
                  disabled={this.state.isRefundSubmitting || this.state.isVoidSubmitting}
                >
                  {this.state.isRefundSubmitting
                    ? "Refunding..."
                    : this.state.selectedObject.paymentGateway === PaymentGatewaysEnum.TRUST_COMMERCE
                      ? "Refund / Reverse"
                      : "Refund"}
                </Button>
              )}
              &nbsp;&nbsp;&nbsp;<Button onClick={() => { this.PrintDetails() }} color="primary" className={classes.primaryButton}>
                {t("Report.iPay.Popup.PrintButton")}
              </Button>
              <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                {t("Report.iPay.Popup.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>

                    <Box component="div">
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
              <Grid item xs={12} md={12} sx={{ textAlign: 'end' }}>
                <Tooltip key="single-edit" title={t("Report.iPay.ExportCSV")}>
                                  <IconButton
                                    style={{ marginRight: '0' }}
                                    aria-label="ExportCSV"
                                    onClick={() => { this.exportCSV() }}
                                    disabled={this.state.isButtonDisabled}
                                  >
                                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                                  </IconButton>
                                </Tooltip>
              </Grid>
            </Grid>
          </Box>
        </div>
        <Divider style={{ marginTop: '10px', height: '5px' }} />

        <div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: 'firstname', headerName: t("Report.iPay.FirstName"), colId: 'firstname' },
              { field: 'lastname', headerName: t("Report.iPay.LastName"), colId: 'lastname' },
              { field: 'PRN', headerName: t("Report.iPay.PRN"), colId: 'PRN' },
              { field: 'store', headerName: t("Report.iPay.Store"), colId: 'store' },
              { field: 'box', headerName: t("Report.iPay.Location"), colId: 'box' },
              { field: 'pucode', headerName: t("Report.iPay.PUCode"), colId: 'pucode' },
              withClickableCell(
                { field: 'transaction_id', headerName: t("Report.iPay.TransactionID"), colId: 'transaction_id', valueGetter: (p) => (p.data && (p.data.transaction_id || p.data.trans_id)) || '' },
                (e, row) => this.handlePUcodeClick(e, row)
              ),
              { field: 'trans_status', headerName: t("Report.iPay.TransactionStatus"), colId: 'trans_status', valueGetter: (p) => (p.data && (p.data.trans_status || p.data.host_response_description)) || '' },
              { field: 'masked_card_number', headerName: t("Report.iPay.CardNumber"), colId: 'masked_card_number', valueGetter: (p) => (p.data && (p.data.masked_card_number || p.data.account_no)) || '' },
              { field: 'card_type', headerName: t("Report.iPay.CardType"), colId: 'card_type' },
              { field: 'card_brand', headerName: t("Report.iPay.CardBrand"), colId: 'card_brand' },
              { field: 'entry_type', headerName: t("Report.iPay.EntryType"), colId: 'entry_type' },
              { field: 'reference_id', headerName: t("Report.iPay.ReferenceID"), colId: 'reference_id' },
              withDateColumnFilter({ field: 'payment_date', headerName: t("Report.iPay.PaymentDateTime"), colId: 'payment_date', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
              { field: 'payment_type', headerName: t("Report.iPay.PaymentType"), colId: 'payment_type', valueGetter: (p) => (p.data && (p.data.payment_type || p.data.card_type)) || '' },
              { field: 'currency_code', headerName: t("Report.iPay.CurrencyCode"), colId: 'currency_code' },
              { field: 'approved_amt', headerName: t("Report.iPay.TotalAmount"), colId: 'approved_amt', valueFormatter: (p) => p.value ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              { field: 'type', headerName: t("Report.iPay.Type"), colId: 'type', valueFormatter: (p) => p.value ? String(p.value).toUpperCase() : '' },
              { field: 'selected_payment_gateway', headerName: "Gateway", colId: 'selected_payment_gateway', valueFormatter: (p) => getGatewayLabel(p.value) },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/ipay_transaction/index.js